export let debitAdviceTemplate = `
<%# {"versionInfo":{"buildMinVersion":12,"buildMaxVersion":999,"name":"Bosch EJS"},"additionalProperties":{}, "dynamicFormDataType" : []} %>
<style>
    .container {
        height: 100%;
        position: relative;
        font-family: 'Times New Roman', Times, serif;
        word-wrap: break-word;
        color: #000000;
        margin-bottom: 20px;
    }

    .mainContent {
        margin: 100px 80px 50px;
        page-break-after: always
    }

    .flexBox {
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .col-24 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .col-20 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.33333333%;
        flex: 0 0 83.33333333%;
        max-width: 83.33333333%;
    }

    .col-16 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.66666667%;
        flex: 0 0 66.66666667%;
        max-width: 66.66666667%;
    }

    .col-12 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-8 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.33333333%;
        flex: 0 0 33.33333333%;
        max-width: 33.33333333%;
    }

    .col-6 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-4 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.66666667%;
        flex: 0 0 16.66666667%;
        max-width: 16.66666667%;
    }

    .col-2 {
        display: block;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.33333333%;
        flex: 0 0 8.33333333%;
        max-width: 8.33333333%;
    }

    .col {
        position: relative;
        max-width: 100%;
        min-height: 1px;
    }

    .leftAlign {
        text-align: left;
    }

    .marginTop {
        margin-top: 30px;
    }

    .marginBottom {
        margin-bottom: 20px;
    }

    .borderbottom {
        border-bottom: 1px solid #000000;
    }

    .borderTop {
        border-top: 1px solid #000000;
    }

    .fontsize12 {
        font-size: 12px
    }

    .fontsize14 {
        font-size: 14px
    }

    .table {
        width: 90%;
        margin: 5px auto;
    }

    .rightAlign {
        text-align: right
    }

    .upperCase {
        text-transform: upperCase
    }

    .centerAlign {
        text-align: center;
    }


    .tableHeader {
        counter-increment: tableHeader;
    }

    .pageNumber::before {
        content: counter(tableHeader) '/';
    }


    .fontWeightNormal {
        font-weight: normal
    }

    .fontsize18 {
        font-size: 18px;
    }

    .fontsize15 {
        font-size: 15px;
    }

    .logo {
        width: 12px;
        height: 12px;
    }


    .padding {
        padding: 25px 0 10px;
    }

    .marginTopSmall {
        margin-top: 8px;
    }

    .paddingRight {
        padding-right: 10px;
    }

    .paddingtop {
        padding-top: 15px;
    }
</style>
<div class="container fontsize14" id="divToPrint">
    <div class="mainContent">
        <div class="flexBox">
            <div class="col-16 leftAlign paddingRight">
                <div><b>From Location:</b></div>
                <div><b>Plant/WH Code:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantCode && JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantCode?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? 
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantCode : 
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantCode
                        : "-" %>
                </div>
                <div><b>Plant Name:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantName && JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantName ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? 
                        upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantName) : 
                            upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantName)
                        : "-" %>
                </div>
                <div><b>Address</b></div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>
                            <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1)%>
                        <% } %>
                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2)
                            %>
                            <% } %>

                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.city) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.city)
                            %>
                            <% } %>

                </div>

                <div>
                        <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                                { %>

                                <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.state) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.state)
                                    %>
                                    <% } %>
                        <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ?
                                JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.pinCode
                                :
                                JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.pinCode
                            : "-" %>
                            


                </div>

            </div>

            <div class="col-8 leftAlign">
                <div><b> Invoice</b></div>
                <div>
                    <b>LSP:</b>
                    <%= upperCase(jsonLd.provider.name) %>
                </div>
                <div><b>Address:</b></div>
                <div>
                    <%= jsonLd.provider.address.streetAddress && upperCase(jsonLd.provider.address.streetAddress) %>
                </div>
                <div>
                    <%= jsonLd.provider.address.addressLocality && upperCase(jsonLd.provider.address.addressLocality) %>
                </div>

                <div><b>Vendor Code:</b>
                    <%= upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).lspID)
                        %>
                </div>
                <div><b>PO/Contract Number:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).poContactNumber
                        ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).poContactNumber
                        : "-" %>
                </div>
                <div><b>Vendor GSTN:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).gstNo ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).gstNo : "-"
                        %>
                </div>
            </div>
        </div>
        <div class="flexBox paddingtop">
            <div class="col-16 leftAlign paddingRight">
                <div><b>Credit to:</b></div>
                <div><b>Legal Entity:</b>
                    <% if(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).legalName)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).legalName
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).legalName: '-'
                            %>
                            <% } %>

                </div>
                <div><b>Bosch Division:
                    </b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantDivision
                        ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? 
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantDivision
                            :
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantDivision
                        : "-" %>
                </div>
                <div><b>Plant/WH Code:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantCode ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ?
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantCode
                        :
                        JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantCode
                        : "-" %>
                </div>
                <div><b>Plant Name:</b>
                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantName) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantName)
                        %>
                </div>
                <div><b>Address</b></div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>
                            <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1)%>
                        <% } %>
                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2)
                            %>
                            <% } %>

                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.city) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.city)
                            %>
                            <% } %>

                </div>

                <div>
                        <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                                { %>

                                <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.state) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.state)
                                    %>
                                    <% } %>
                        <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ?
                                JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.pinCode
                                :
                                JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.pinCode
                            : "-" %>
                            


                </div>

            </div>

            <div class="col-8 leftAlign">
                <% if(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).userName ||
                    JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).email ||
                    JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).phoneNumber) { %>
                    <div><img class="logo"
                            src="data:image/png;base64,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" />
                        <b> Bosch Username:</b>
                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).userName
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).userName
                            :'-' %>
                    </div>
                    <div>

                        <img class="logo"
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAZlBMVEX///8AAAAwMDDo6Oj5+fmXl5fPz893d3fW1tb09PS4uLjT09M0NDT8/PycnJxVVVXt7e1ubm4oKChOTk4ODg69vb1LS0tZWVl7e3uSkpJCQkJzc3MhISGzs7MQEBAaGho6OjpnZ2d2P8BCAAAEwElEQVR4nO2daVciMRBFA40LIoqC4r78/z85Z5welZ6XrVOVdDnvfgWaXGkeVVmOzhFCCCGEEEIIIYQQQgghhEyE+U/HzX46NLQPDe1DQ/vQ0D40tA8N7eM3PFp2dlgejTCcHbVu7DLwCwbv0sfW407mMWAR/B7eLloPPYnFbUginDTzTevRJ7CZBx1iWXrcevxRjiMG0V+L59YGEZ5jAvHfw2lHaiBEkw0nHamhEMWG5+g5D1ON1MUDGu7AYWC42KPXzLvWLpAOhuh+ETR07g69ajfFSD3eoaHeuaHS0NDz3T1r7fMPZ3Ccv3MxZhh46ZQIfBBRQ7eCH/+0IhWG6G718Vjc0HXX6PXb6UTqYosGeN0HYoKhW8MrPE0lUrsn+Ams+4dTDJ07QdeYrdoYDVjBsZ18Pp5m6C7gZaZQpeJK9OLrCYmG7gZe6L660JB7OK6bb89INXSrF3Spk7VryRp+fV4Ovj7Jhq6DVerlsqrSIctLNKTzwwhMN3RrWNk+tWv8NzBEHwa3VYahL1JbVam4nT8ZPi3LcFKRGg3RnjzDCVWpyS1BpmH097UW6TVIrqHb4Ma/bqQucTsPQy/bMFLnViGrF8g39NwhFRt/3M77viljDBs3/plpN8rQ8yZ1qlRcifr/vOMMGzb+oXYeMtLQ03Zeajf+C1iJBpvxsYaexv9VN1K7V/Sm22CDM9rQM5eqWqXiSvQu/KICQ0+k6lWpuBKNlYwlhpUb/3g7DykydKfwTa9EhIZcwfc6jb6uzNB1b+htFRp/3M6/JQRboaHnncWrVFyJJv0lSw3H3z05lHwbyg0rNP6p7TxEwFA9UkeGaI+EoXLjX7ikIGLomUvdSkTqElaH5+lRJmPoqYgFItUTohkVvpCh1vKUwP0vZqgSqUUh2iNnqDCXKjJbImgoHqkyN76koeyKv9SspaihZKSWh2iPrKFc4z+qnYdIGwrNpQqmlrihyOAkp5zlDT2tznvGFd7hFUY2ZAqGpSv+Savz6WgYlo1RekeEiqFvP3LKfYbv8YL1AiXD0XOp4+ZEQ2gZjlyeyl1YSkDNcNTtNv7m9qNn6DmfEzg9hU8slZ5FUjR0eKu/t0rFlei+dMFO0zBvE1XiFqdsdA0zyi+1vUjKhslzqWVzoiG0DRNX/LNX59NRN/Sc1jlo/HE7L3T6SN8wPh2he9yhgmGs8Zdr5yFVDD1zqX8iFYdo3pxoiDqGgd8C9R1klQy9a5z666u1DN0GxgnkWnRzfDVDt4RVKmAvu8+hnqGvSh0ivaO6pmHCYXKFXfFVDT2R+h35bbh1DT2R+oXsJpUPKhuGI1U2RHtqG3oa/w+K23lIdUN/pCodS2lg6KlS5SrRQ1oYwsZfop2HNDF0x8MDqS96m6fbGA6bXs0zRY0M3fr77O+t5mniVobfG3+xdh7SzvAzUrVCtKehYV+lah8Ia2noTneznUIlekhTQ9dt9Q9mtjWsAQ3tQ0P70NA+NLQPDe1DQ/vQ0D40tA8N7UND+9DQPjS0Dw3tQ0P70NA+NLQPDe1DQ/vQ0D40tA8N7UND+/znhq3/v7YIQcMfCA3tQ0P70NA+NLQPDe1DQ/u4+U+ndS9HCCGEEEIIIYQQQgghhBDyl19qgVJKnEl//AAAAABJRU5ErkJggg==" />
                        <b>Email:</b>
                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).email ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).email
                            :'-' %>
                    </div>
                    <div>
                        <img class="logo"
                            src="data:image/png;base64,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" />
                        <b>Ph.No:</b>
                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).phoneNumber
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).phoneNumber:'-'%>
                    </div>
                    <% } %>


                        <% if(!JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).userName
                            && !JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).email
                            &&
                            !JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).phoneNumber)
                            { %>
                            <div><img class="logo"
                                    src="data:image/png;base64,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" />
                                <b> Bosch Username:</b> -
                            </div>
                            <div>

                                <img class="logo"
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAZlBMVEX///8AAAAwMDDo6Oj5+fmXl5fPz893d3fW1tb09PS4uLjT09M0NDT8/PycnJxVVVXt7e1ubm4oKChOTk4ODg69vb1LS0tZWVl7e3uSkpJCQkJzc3MhISGzs7MQEBAaGho6OjpnZ2d2P8BCAAAEwElEQVR4nO2daVciMRBFA40LIoqC4r78/z85Z5welZ6XrVOVdDnvfgWaXGkeVVmOzhFCCCGEEEIIIYQQQgghhEyE+U/HzX46NLQPDe1DQ/vQ0D40tA8N7eM3PFp2dlgejTCcHbVu7DLwCwbv0sfW407mMWAR/B7eLloPPYnFbUginDTzTevRJ7CZBx1iWXrcevxRjiMG0V+L59YGEZ5jAvHfw2lHaiBEkw0nHamhEMWG5+g5D1ON1MUDGu7AYWC42KPXzLvWLpAOhuh+ETR07g69ajfFSD3eoaHeuaHS0NDz3T1r7fMPZ3Ccv3MxZhh46ZQIfBBRQ7eCH/+0IhWG6G718Vjc0HXX6PXb6UTqYosGeN0HYoKhW8MrPE0lUrsn+Ams+4dTDJ07QdeYrdoYDVjBsZ18Pp5m6C7gZaZQpeJK9OLrCYmG7gZe6L660JB7OK6bb89INXSrF3Spk7VryRp+fV4Ovj7Jhq6DVerlsqrSIctLNKTzwwhMN3RrWNk+tWv8NzBEHwa3VYahL1JbVam4nT8ZPi3LcFKRGg3RnjzDCVWpyS1BpmH097UW6TVIrqHb4Ma/bqQucTsPQy/bMFLnViGrF8g39NwhFRt/3M77viljDBs3/plpN8rQ8yZ1qlRcifr/vOMMGzb+oXYeMtLQ03Zeajf+C1iJBpvxsYaexv9VN1K7V/Sm22CDM9rQM5eqWqXiSvQu/KICQ0+k6lWpuBKNlYwlhpUb/3g7DykydKfwTa9EhIZcwfc6jb6uzNB1b+htFRp/3M6/JQRboaHnncWrVFyJJv0lSw3H3z05lHwbyg0rNP6p7TxEwFA9UkeGaI+EoXLjX7ikIGLomUvdSkTqElaH5+lRJmPoqYgFItUTohkVvpCh1vKUwP0vZqgSqUUh2iNnqDCXKjJbImgoHqkyN76koeyKv9SspaihZKSWh2iPrKFc4z+qnYdIGwrNpQqmlrihyOAkp5zlDT2tznvGFd7hFUY2ZAqGpSv+Savz6WgYlo1RekeEiqFvP3LKfYbv8YL1AiXD0XOp4+ZEQ2gZjlyeyl1YSkDNcNTtNv7m9qNn6DmfEzg9hU8slZ5FUjR0eKu/t0rFlei+dMFO0zBvE1XiFqdsdA0zyi+1vUjKhslzqWVzoiG0DRNX/LNX59NRN/Sc1jlo/HE7L3T6SN8wPh2he9yhgmGs8Zdr5yFVDD1zqX8iFYdo3pxoiDqGgd8C9R1klQy9a5z666u1DN0GxgnkWnRzfDVDt4RVKmAvu8+hnqGvSh0ivaO6pmHCYXKFXfFVDT2R+h35bbh1DT2R+oXsJpUPKhuGI1U2RHtqG3oa/w+K23lIdUN/pCodS2lg6KlS5SrRQ1oYwsZfop2HNDF0x8MDqS96m6fbGA6bXs0zRY0M3fr77O+t5mniVobfG3+xdh7SzvAzUrVCtKehYV+lah8Ia2noTneznUIlekhTQ9dt9Q9mtjWsAQ3tQ0P70NA+NLQPDe1DQ/vQ0D40tA8N7UND+9DQPjS0Dw3tQ0P70NA+NLQPDe1DQ/vQ0D40tA8N7UND+/znhq3/v7YIQcMfCA3tQ0P70NA+NLQPDe1DQ/u4+U+ndS9HCCGEEEIIIYQQQgghhBDyl19qgVJKnEl//AAAAABJRU5ErkJggg==" />
                                <b>Email:</b> -
                            </div>
                            <div>
                                <img class="logo"
                                    src="data:image/png;base64,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" />
                                <b>Ph.No:</b> -
                            </div>
                            <% } %>


            </div>
        </div>


        <div class=" flexBox marginTop marginBottom">
            <div class="col-16  leftAlign">
                DA ID:<b>
                    <%= jsonLd.debitAdviceNumber %>
                </b>
            </div>
            <div class="col-4">Debit Advice Generated Date:</div>
            <div class="col-4">
                <%= dateConversion(jsonLd.recordAdded) %>
            </div>
        </div>
        <div class="borderTop"></div>
        <div class="flexBox leftAlign" style="margin-top:10px">
            <div class="col-12">We charge you for the following damages / losses in-cured to our goods due to mishandling of goods at your end</div>
            <div class="rightAlign" style="width:100%;">INR <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
            </div>
        </div>
        <div class="flexBox marginTop">
            <div class="col-12 rightAlign"></div>
            <div class="col-12">
                <div class="flexBox">

                    <div class="col-12 leftAlign" style="margin:0 1px">Net amount:</div>
                    <div class="col-12 leftAlign">
                        <div class="flexBox">
                            <div class="col-12">INR</div>
                            <div class="rightAlign" style="width:100%">
                                <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flexBox">
            <div class="col-12 rightAlign">XX IN 0,0 % GST of:</div>
            <div class="col-12 borderbottom">
                <div class="flexBox">
                    <div class="col-12 leftAlign" style="margin:0 1px">
                        <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                    </div>
                    <div class="col-12 leftAlign">
                        <div class="flexBox">
                            <div class="col-12">INR</div>
                            <div class="rightAlign" style="width:100%">
                                <%= toFixed(000) %>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flexBox">
            <div class="col-12 rightAlign"></div>
            <div class="col-12 borderbottom">
                <b class="flexBox">
                    <div class="col-12 leftAlign" style="margin:0 1px">Gross amount:</div>
                    <div class="col-12 leftAlign">
                        <div class="flexBox">
                            <div class="col-12">INR</div>
                            <div class="rightAlign" style="width:100%">
                                <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                            </div>
                        </div>
                    </div>
                </b>
            </div>
        </div>

    </div>
    <table class="table fontsize12">

        <thead class="tableHeader ">
            <tr>
                <th class="fontWeightNormal">
                    <div class="padding">
                        <div class="flexBox borderbottom">
                            <div class="col-20 leftAlign">
                                <%= upperCase(jsonLd.provider.name) %>
                                    <%if (jsonLd.provider.address.streetAddress) { %>
                                        ,<%= upperCase(jsonLd.provider.address.streetAddress) %>
                                            <% } %>
                                                <%if (jsonLd.provider.address.addressLocality) { %>

                                                    ,<%= upperCase(jsonLd.provider.address.addressLocality) %>
                                                        <% } %>







                            </div>
                        </div>
                        <div class="flexBox paddingtop">
                            <div class="col-12 leftAlign">
                                <div class="fontsize18"><b>Debit Advice</b></div>
                                <div>
                                </div>
                                <div>

                                    <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantCode) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantCode)
                                        %>
                                        <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantName)
                                            { %>

                                            , <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantName) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantName)
                                                %>
                                                <% } %>

                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine1) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1 && upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine1)
                            %>
                            <% } %>

                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.addressLine2) : JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2 &&upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.addressLine2)
                            %>
                            <% } %>

                </div>
                <div>
                    <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                        { %>

                        <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.city) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.city)
                            %>
                            <% } %>

                </div>

                <div>
                        <%if (JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress)
                                { %>

                                <%= JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.state) : upperCase(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.state)
                                    %>
                                    <% } %>
                        <%=JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress
                            ?
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).isOriginChanged ? 
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).destinationPlantAddress.pinCode
                            :
                            JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).plantAddress.pinCode
                            : "-" %>



                </div>



                                </div>
                    
                            </div>
                            <div class="col-6 rightAlign" style="margin-right:12px">
                                <div>&nbsp</div>
                                <div>CN ID</div>
                                <div>CN Generated Date</div>
                            </div>
                            <div class="col-6 leftAlign">
                                <div>&nbsp</div>
                                <div>
                                    <%= jsonLd.debitAdviceNumber %>
                                </div>
                                <div>
                                    <%= dateConversion(jsonLd.recordAdded) %>
                                </div>
                            </div>
                        </div>
                        <div class="flexBox marginTopSmall borderbottom">
                            <div class="col-4 leftAlign" style="margin-right:10px"><b>References</b></div>
                            <div class="col-8 leftAlign" style="margin-right:10px"><b>Date / OrderNumber /
                                    Details</b>
                            </div>
                            <%if(JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).relatedCNs && JSON.parse(jsonLd.referencesOrder.orderedItem[0].orderedItem.additionalProperties).relatedCNs.length !== 0 ){%>
                                <div class="col-8 leftAlign" style="margin-right:10px"><b>Related Clearing Details</b></div>
                            <%}%>
                            <div class="col-8 leftAlign" style="margin-right:10px"><b>Calculation</b></div>
                        </div>
                    </div>
                </th>
            </tr>

            </tr>
        </thead>
        <tbody>
            <% jsonLd["referencesOrder"].orderedItem.forEach(function(item){ %>

                <tr>

                    <td>
                        <div class="flexBox borderbottom">

                            <div class="col-4 leftAlign" style="margin-right:7px">

                                <% !JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData ? "-" :
                                    JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData.invNumber.forEach(function(invNumber){
                                    %>
                                    <div>
                                        <%= invNumber %>
                                    </div>
                                    <% }); %>
                                        <% !JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData ? "-" :
                                            JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData.obd.forEach(function(obd){
                                            %>
                                            <div>
                                                <%= obd %>
                                            </div>
                                            <% }); %>
                                                <div>
                                                    <%= JSON.parse(item.orderedItem.additionalProperties) ?
                                                        JSON.parse(item.orderedItem.additionalProperties).tripID : "-"
                                                        %>
                                                </div>
                                                <div>
                                                    <%= JSON.parse(item.orderedItem.additionalProperties).vehicleType %>
                                                </div>
                                                <div>
                                                    <%= JSON.parse(item.orderedItem.additionalProperties).freightServiceMode
                                                        %>
                                                </div>

                            </div>
                            <div class="col-4 leftAlign" style="margin-right:7px">
                                <div class="flexBox">
                                    <div style="margin-right:10px">
                                        <%= dateConversion(JSON.parse(item.orderedItem.additionalProperties).tripStart)
                                            %>
                                    </div>
                                    <div>
                                        <%= JSON.parse(item.orderedItem.additionalProperties) ?
                                            JSON.parse(item.orderedItem.additionalProperties).lrID : "-" %>
                                    </div>

                                </div>
                                <div>
                                    <%= JSON.parse(item.orderedItem.additionalProperties).plantCode %>

                                        <%= JSON.parse(item.orderedItem.additionalProperties).plantName
                                            ?upperCase(JSON.parse(item.orderedItem.additionalProperties).plantName):'-'
                                            %>
                                            <%= JSON.parse(item.orderedItem.additionalProperties).plantAddress ?
                                                (JSON.parse(item.orderedItem.additionalProperties).plantAddress).pinCode:'-'
                                                %>

                                </div>
                                <div>
                                    <%= JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData ?
                                        JSON.parse(item.orderedItem.additionalProperties).salesInvoiceData.noOfBoxes
                                        : "-" %> boxes
                                </div>
                            </div>
                            <div class="col-4 leftAlign" style="margin-right:7px">
                                <div class="flexBox" style="flex-wrap : wrap">
                                    <%if(["FTL","MR","RT","MGB"].includes(JSON.parse(item.orderedItem.additionalProperties).freightServiceMode) )
                                        { %>
                                        <%= JSON.parse(item.orderedItem.additionalProperties) ?
                                            volumeinm3(JSON.parse(item.orderedItem.additionalProperties)) : "-" %>m<sup>3</sup>
                                            <% } %>
                                                <%if(JSON.parse(item.orderedItem.additionalProperties).freightServiceMode==='LTL'
                                                    ) { %>
                                                    <div style="margin-right:10px">
                                                        <%= JSON.parse(item.orderedItem.additionalProperties).plantWeight
                                                            ?
                                                            toFixed(JSON.parse(item.orderedItem.additionalProperties).plantWeight)
                                                            : "-" %>kgs

                                                    </div>
                                                    <div style="margin-right:10px">
                                                        <%= JSON.parse(item.orderedItem.additionalProperties) ?
                                                            volumeinm3(JSON.parse(item.orderedItem.additionalProperties))
                                                            : "-" %>m<sup>3</sup>
                                                    </div>
                                                    <div>
                                                        <%= JSON.parse(item.orderedItem.additionalProperties).consignorVolume
                                                            ?
                                                            toFixed(JSON.parse(item.orderedItem.additionalProperties).consignorVolume)
                                                            : "-" %>kg
                                                    </div>
                                                    <% } %>


                                </div>
                                <div>
                                    <%= JSON.parse(item.orderedItem.additionalProperties).destinationPlantCode %>

                                        <%= JSON.parse(item.orderedItem.additionalProperties).destinationPlantName ?
                                            JSON.parse(item.orderedItem.additionalProperties).destinationPlantName:'-'
                                            %>
                                            <%=JSON.parse(item.orderedItem.additionalProperties).destinationPlantAddress
                                                ?
                                                JSON.parse(item.orderedItem.additionalProperties).destinationPlantAddress.pinCode:'-'
                                                %>

                                </div>
                                <div>
                                    <%= JSON.parse(item.orderedItem.additionalProperties).chargeableWeight ?
                                        toFixed(JSON.parse(item.orderedItem.additionalProperties).chargeableWeight)
                                        : "-" %> Kgs
                                </div>
                            </div>

                            <%if(JSON.parse(item.orderedItem.additionalProperties).relatedCNs && JSON.parse(item.orderedItem.additionalProperties).relatedCNs.length !== 0 ){%>
                                <div class="col-4 leftAlign" style="margin-right:7px">
                                    
                                    <% JSON.parse(item.orderedItem.additionalProperties).relatedCNs.forEach((cnID)=>{ %>
                                        <div>
                                            <%= cnID %>
                                        </div>
                                    <%})%>
                                </div>
                            <%}%>

                            <div class="col-8">
                                <div class="flexBox">
                                    <div class="col-8">Freight Charges
                                        <div>
                                            <%if(JSON.parse(item.orderedItem.additionalProperties).freightServiceMode==='LTL'
                                                ) { %>

                                                <%= JSON.parse(item.orderedItem.additionalProperties).chargeableWeight ?
                                                    toFixed(JSON.parse(item.orderedItem.additionalProperties).chargeableWeight)
                                                    : "-" %> Kgs (
                                                    <%= rupeesStandardFormat(item.orderedItem.offers.price) %>)
                                                        <% } %>

                                                            <%if(["FTL","MR","RT","MGB"].includes(JSON.parse(item.orderedItem.additionalProperties).freightServiceMode)
                                                                ) { %>
                                                                    <%= item.orderedItem.additionalProperties && JSON.parse(item.orderedItem.additionalProperties).chargeableWeightInPercentage ? toFixed(JSON.parse(item.orderedItem.additionalProperties).chargeableWeightInPercentage) : "100"  %>%(
                                                                        <%=rupeesStandardFormat( JSON.parse(item.orderedItem.additionalProperties).rateCardAmount ? JSON.parse(item.orderedItem.additionalProperties).rateCardAmount : item.orderedItem.offers.price)%>
                                                                    )
                                                                    <% } %>

                                        </div>
                                    </div>
                                    <div class="col-12 rightAlign" style="padding-left:20px">
                                        <span>Rs.<%= rupeesStandardFormat(getRate(item)) %>
                                        </span>
                                        <span style="padding-left:20px">0,0% in XX</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <% }); %>
                    <tr>
                        <td>
                            <div class="flexBox marginTop">
                                <div class="col-12 rightAlign"></div>
                                <div class="col-12">
                                    <div class="flexBox">
                                        <div class="col-12 leftAlign" style="margin:0 1px">Net amount:</div>
                                        <div class="col-12 leftAlign">
                                            <div class="flexBox">
                                                <div class="col-12">INR</div>
                                                <div class="rightAlign" style="width:100%">
                                                    <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="flexBox">
                                <div class="col-12 rightAlign"></div>
                                <div class="col-12 borderbottom">
                                    <div class="flexBox">
                                        <div class="col-12 leftAlign" style="margin:0 1px">
                                            0,0 % GST of:
                                        </div>
                                        <div class="col-12 leftAlign">
                                            <div class="flexBox">
                                                <div class="col-12">
                                                    <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                                                </div>
                                                <div class="rightAlign" style="width:100%">
                                                    <%= toFixed(000) %>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flexBox">
                                <div class="col-12 rightAlign"></div>
                                <div class="col-12 borderbottom">
                                    <b class="flexBox">
                                        <div class="col-12 leftAlign" style="margin:0 1px">Gross amount:</div>
                                        <div class="col-12 leftAlign">
                                            <div class="flexBox">
                                                <div class="col-12">INR</div>
                                                <div class="rightAlign" style="width:100%">
                                                    <%= rupeesStandardFormat(jsonLd.totalPaymentDue.price) %>
                                                </div>
                                            </div>
                                        </div>
                                    </b>
                                </div>
                            </div>
                        </td>
                    </tr>

        </tbody>
        <tfoot>


            <tr>

                <td style="padding:10px 0"></td>
            </tr>
        </tfoot>
    </table>
</div>
<% var i=0; 
    function toFixed (text, precision = 2) {
        let number = Number(text)
        if (isNaN(number) || number === undefined) {
            return 0.00
        }
        number = number.toFixed(precision)
        return number;
    }
    function totalNoOfPackages(invoices) {
    if(!invoices){
    return "-"
    }
    let data=0;
    invoices && invoices.forEach((singleItem)=> {
    singleItem.invLineItems.forEach(count => {
    data = data + parseInt(count.noOfBoxes);
    })
    });
    return data
    }

    function max(item) {
    let data = [];
    data.push(item.lrData.plantWeight);
    data.push(item.lrData.confirmWeight);
    data.push(item.lrData.consignorInfo.consignorVolume);
    return Math.max(...data)
    }

    function upperCase(str) {
    if(!str){
    return "-"
    }
    str = str.toUpperCase();
    return str
    }

    function dateConversion(date) {
    let startTime = new Date(date);
    let day = startTime.getDate();
    let zero='0'
    if(day && day<=9){
      day =zero+day
    }
    let month = startTime.getMonth() + 1;
        if(month && month <= 9){
      month =zero+(month)
    }


    let year = startTime.getFullYear();
    return day + "/" + month + "/" + year;
    }

    function rupeesStandardFormat(text,precision = 2) {
    if(typeof text === 'string')
    text = Number(text)
    if(text === NaN){
        text = 0
    }
    return (text).toLocaleString("en-IN",{
    maximumFractionDigits: 2,
    minimumFractionDigits : 2
    }) // "12,34,567.80" replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
    }

    function volumentricWeight (text, precision = 2) {
        const values = String(text)
        const index = values && values.indexOf('.')
        if (index === - 1) {
            return Number(parseFloat(text).toFixed(4));
        }
        const splitValues = values && values.substring(0, index + 5)
        return Number(splitValues)
    }

    function volumeinm3(item){
    let amount = item.length *item.breadth*item.height
    console.log("Amount / Item", amount , item)
    return volumentricWeight(amount)
    }

    function getFTLValue(finalPrice, percentage){
        let final = Number(finalPrice)
        let percent = Number(percentage)
        if(isNaN(percent)){
            percent = 100
        }
        if(isNaN(final)){
            return finalPrice
        }
        return (final * 100)/percent
    }

    

    function getRate(item){
        if(!item){
            return 0;
        }
        let orderQuantityTemp = item.orderQuantity
        let additionalProperties = {};
        try{
            additionalProperties = JSON.parse(item.orderedItem.additionalProperties)
        }catch(e){
            additionalProperties = {}
        }
        if (additionalProperties.minChargeableWeight) {
            orderQuantityTemp = additionalProperties.minChargeableWeight
        }
        return orderQuantityTemp * item.orderedItem.offers.price
    }

    

    %>
`